module.exports = __webpack_public_path__ + "img/business.9d26462c.png";